import { parseDate, parseTime, toCalendarDateTime, toZoned, ZonedDateTime } from '@internationalized/date';

export const SUPPORT_EMAIL = 'support@transmedics.com';

const zonedToDate = (zoned: ZonedDateTime): Date =>
  new Date(
    Date.UTC(zoned.year, zoned.month - 1, zoned.day, zoned.hour, zoned.minute, zoned.second, zoned.millisecond) -
      zoned.offset,
  );

export const buildZonedValue = (dateVal: string, timeVal: string, timezone: string): ZonedDateTime | null => {
  if (!dateVal || !timeVal || !timezone) return null;
  const dt = toCalendarDateTime(parseDate(dateVal), parseTime(timeVal));
  return toZoned(dt, timezone);
};

export const formatZonedTime = (zoned: ZonedDateTime): string =>
  `${String(zoned.hour).padStart(2, '0')}:${String(zoned.minute).padStart(2, '0')}`;

export const buildUtcDate = (dateStr: string, timeStr: string, timezone: string): Date => {
  const zoned = buildZonedValue(dateStr, timeStr, timezone);
  return zoned ? zonedToDate(zoned) : new Date(dateStr);
};

export const getDstCorrectedTime = (dateVal: string, timeVal: string, timezone: string): string | null => {
  const zoned = buildZonedValue(dateVal, timeVal, timezone);
  if (!zoned) return null;

  const parsed = parseTime(timeVal);
  const timeShifted = zoned.hour !== parsed.hour || zoned.minute !== parsed.minute;
  return timeShifted ? formatZonedTime(zoned) : null;
};

export const isLessThanSixHours = (dateStr: string, timeStr: string, timezone: string): boolean => {
  const zoned = buildZonedValue(dateStr, timeStr, timezone);
  if (!zoned) return false;

  const diffMs = zonedToDate(zoned).getTime() - Date.now();
  return diffMs >= 0 && diffMs < 6 * 60 * 60 * 1000;
};
